import { LOADED, STATUS_CREATED, STATUS_NOT_LOADED } from "../../api/constant";

export const types = {
  RELOAD_MOVEMENT: "reload_movement",
  RELOAD_OBSERTATIONS: "reload_observations",
  RELOAD_DOCUMENTS: "reload_documents",
  CHANGE_INPUT_HAND_OUT_FORM: "change_input_hand_out_form",
  OBSERVATIONS_LOADED: "observations_loaded",
  DOCUMENTS_LOADED: "documents_loaded",
  ITEMS_FOUND: "items_found",
  ITEMS_ADD: "items_add",

  CHANGE_PAYLOAD_HAND_OUT: "change_payload_hand_out",
  CHANGE_INPUT_HAND_OUT: "change_input_hand_out",
  CHANGE_INPUT_HAND_OUT_BY_OBJECT: "chanhge_input_hand_out_by_object",
  SET_PAYLOAD_MOVEMENT: "set_payload_movement",
  REMOVE_ARTICLE: "remove_article",
  LOAD_INVENTORY_ITEM: "load_invemtory_item",
  CHANGE_INPUT_ITEMS_FORM: "change_input_items_form",
  CHANGE_STATUS_LOOK_FOR_CODE: "change_status_look_for_code",
  CHANGE_PAYLOAD_ITEMS: "change_payload_items",
  RELOAD_ITEMS_HAND_OUT: "reload_items_hand_out",
  LOADED_ITEMS_HAND_OUT: "reload_items_hand_out",
  REMOVE_ITEM_SEARCH: "remove_item_search",
  FRESH_STATUS_ITEMS_CONSUME: "fresh_status_items_consume",
  RELOAD_STATUS_ITEMS_CONSUME: "reload_status_items_consume",
  SET_PAYLOAD_INVENTORY_ITEM: "set_payload_inventory_item",
  SET_ITEM_SELECTED_OUT: "set_item_selected_out",
  FRESH_STATUS_LOTES_ITEMS: "fresh_status_lotes_item",
  LOAD_INVENTORY_LOTES_ITEM: "load_inventory_lotes_item",
  RELOAD_INVENTORY_LOTES_ITEM: "reload_inventory_lotes_item",
  LOADED_INVENTORY_LOTES_ITEM: "loaded_inventory_lotes_item",

  RELOAD_MEASURES: "reload_measures",
  LOADED_MEASURES: "loaded_measures",
  LOAD_MEASURES: "load_measures",

  CHANGE_ITEM_SELECTED_LOTE: "change_item_selected_lote"

};
export const INITIAL_STATE = {
  loading: false,
  lookForCode: "",
  lookForStatus: STATUS_NOT_LOADED,
  lookedItems: [],
  movement: {
    item_header_id: null,
    item_header_name: "",
    item_header_code: "",
    movement_id: null,
    type: "",
    status_id: null,
    created_at: new Date(),
    warehouse_id: null,
    status: STATUS_NOT_LOADED,
    observation: {
      text: "",
      status: STATUS_NOT_LOADED,
      observations: [],
    },
    inventory: {
      status: STATUS_NOT_LOADED,
      items: [],
    },
    document: {
      status: STATUS_NOT_LOADED,
      documents: [],
    },
  },
  item: {
    item_id: null,
    parent_id: null,
    item_name: "",
    item_code: "",
    item_presentation: "",
    item_quantity: 0,
  },
  items_consume: {
    items_consume: [],
    status: STATUS_NOT_LOADED,
  },
  inventory_item: {
    status: STATUS_NOT_LOADED,
    items: [],
  },
  item_selected_out: {
    test_detail_id: null,
    abreviature: "",
    measure_id: null,
    quantity_consume: 0,
  },
  lotes_item: {
    lotes_item: [],
    status: STATUS_NOT_LOADED,
  },
  measures:{
    measures: [],
    status: STATUS_NOT_LOADED,
  },
  item_selected_lote:{
    item_name: "",
    item_measure_name:"",
    item_code: ""
  }
};

export const handOutReducer = (state, action) => {
  const payload = action.payload;
  const {
    RELOAD_OBSERTATIONS,
    RELOAD_DOCUMENTS,
    DOCUMENTS_LOADED,
    OBSERVATIONS_LOADED,
    CHANGE_INPUT_HAND_OUT_FORM,
    ITEMS_FOUND,
    CHANGE_PAYLOAD_HAND_OUT,
    CHANGE_INPUT_HAND_OUT,
    CHANGE_INPUT_HAND_OUT_BY_OBJECT,
    SET_PAYLOAD_MOVEMENT,
    REMOVE_ARTICLE,
    LOAD_INVENTORY_ITEM,
    CHANGE_INPUT_ITEMS_FORM,
    CHANGE_STATUS_LOOK_FOR_CODE,
    CHANGE_PAYLOAD_ITEMS,
    RELOAD_ITEMS_HAND_OUT,
    REMOVE_ITEM_SEARCH,
    ITEMS_ADD,
    FRESH_STATUS_ITEMS_CONSUME,
    SET_PAYLOAD_INVENTORY_ITEM,
    SET_ITEM_SELECTED_OUT,
    LOADED_ITEMS_HAND_OUT,
    FRESH_STATUS_LOTES_ITEMS,
    LOAD_INVENTORY_LOTES_ITEM,
    RELOAD_INVENTORY_LOTES_ITEM,
    LOADED_INVENTORY_LOTES_ITEM,
    LOAD_MEASURES,
    RELOAD_MEASURES,
    LOADED_MEASURES,
    RELOAD_STATUS_ITEMS_CONSUME,
    CHANGE_ITEM_SELECTED_LOTE

  } = types;
  switch (action.type) {
    case REMOVE_ARTICLE:
      return {
        ...state,
        lookForCode: "",
        lookedItems: [],
        movement: {
          ...state.movement,
          item_header_id: null,
          item_header_name: "",
          item_header_code: "",
        },
      };
    case SET_PAYLOAD_MOVEMENT:
      return {
        ...state,
        movement: action.payload,
      };
    case CHANGE_INPUT_HAND_OUT_FORM:
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };
    case CHANGE_INPUT_HAND_OUT:
      return {
        ...state,
        movement: {
          ...state.movement,
          [action.payload.name]: action.payload.value,
        },
      };
    case LOAD_INVENTORY_ITEM:
      return {
        ...state,
        movement: {
          ...state.movement,
          inventory: {
            ...state.movement.inventory,
            items: action.payload.items,
            status: LOADED,
          },
        },
      };
    case CHANGE_PAYLOAD_HAND_OUT:
      return {
        ...state,
        movement: action.payload,
      };
    case RELOAD_DOCUMENTS:
      return {
        ...state,
        movement: {
          ...state.movement,
          document: {
            ...state.movement.document,
            status: STATUS_NOT_LOADED,
          },
        },
      };
    case RELOAD_OBSERTATIONS:
      return {
        ...state,
        movement: {
          ...state.movement,
          observation: {
            ...state.movement.observation,
            status: STATUS_NOT_LOADED,
          },
        },
      };
    case DOCUMENTS_LOADED:
      return {
        ...state,
        movement: {
          ...state.movement,
          document: {
            ...state.movement.document,
            documents: action.payload,
            status: LOADED,
          },
        },
      };
    case OBSERVATIONS_LOADED:
      return {
        ...state,
        movement: {
          ...state.movement,
          observation: {
            ...state.movement.observation,
            observations: action.payload,
            status: LOADED,
          },
        },
      };
    case CHANGE_INPUT_HAND_OUT_BY_OBJECT:
      return {
        ...state,
        movement: {
          ...state.movement,
          movement_id: action.payload.movement_id,
          status: action.payload.status,
          status_id: action.payload.status_id,
        },
      };
      case CHANGE_STATUS_LOOK_FOR_CODE:
        return {
          ...state,
          lookForItemStatus: action.payload,
        };  
    case CHANGE_INPUT_ITEMS_FORM:
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };
      case CHANGE_PAYLOAD_ITEMS:
        return {
          ...state,
          item: payload,
        };
        case RELOAD_ITEMS_HAND_OUT:
          return {
            ...state,
              items_consume: {
                ...state.items_consume,
                status: STATUS_NOT_LOADED,
              },
          };
          case LOADED_ITEMS_HAND_OUT:
            return {
              ...state,
                items_consume: {
                  ...state.items_consume,
                  status: LOADED,
                },
            };
          case REMOVE_ITEM_SEARCH:
            return {
              ...state,
              lookForCode: "",
              lookedItems: [],
              item: {
                ...state.item,
                item_id: null,
                item_name: "",
                item_code: "",
                item_presentation: "",
                item_quantity: 0,
              },
            };
    case ITEMS_FOUND:
      return { ...state, lookForStatus: LOADED, lookedItems: action.payload };
    case ITEMS_ADD:
      return { ...state, 
        items_consume:{
          ...state.items_consume,
          items_consume: action.payload,
          status: LOADED,
        }
      };
    case FRESH_STATUS_ITEMS_CONSUME:
      return {
        ...state,
        items_consume: {
          ...state.items_consume,
          items_consume: [...state.items_consume.items_consume],
        },
      };
      case RELOAD_STATUS_ITEMS_CONSUME:
      return {
            ...state,
              items_consume: {
                ...state.items_consume,
                status: STATUS_NOT_LOADED,
              },
      };
    case SET_PAYLOAD_INVENTORY_ITEM:
        return {
          ...state,
          inventory_item: action.payload,
        };
    case SET_ITEM_SELECTED_OUT:
      return {
        ...state,
        item_selected_out: {
          ...state.item_selected_out,
          test_detail_id: action.payload.test_detail_id,
          abreviature: action.payload.abreviature,
          measure_id: action.payload.measure_id,
          quantity_consume: action.payload.quantity_consume,
        },
      };
    case FRESH_STATUS_LOTES_ITEMS:
      return {
          ...state,
          lotes_item: {
            ...state.lotes_item,
            lotes_item: [...state.lotes_item.lotes_item],
          },
      };


    case LOAD_INVENTORY_LOTES_ITEM:
      return { ...state, 
        lotes_item:{
          ...state.lotes_item,
          lotes_item: action.payload,
          status: LOADED,
        }
      };

    case RELOAD_INVENTORY_LOTES_ITEM:
      return {
            ...state,
              items_consume: {
                ...state.items_consume,
                status: STATUS_NOT_LOADED,
              },
      };
      case LOADED_INVENTORY_LOTES_ITEM:
        return {
              ...state,
              lotes_item: {
                  ...state.lotes_item,
                  status: LOADED,
                },
        };

        case LOAD_MEASURES:
          return { ...state, 
            measures:{
              ...state.measures,
              measures: action.payload,
              status: LOADED,
            }
          };

          case RELOAD_MEASURES:
      return {
            ...state,
            measures: {
                ...state.measures,
                status: STATUS_NOT_LOADED,
              },
      };

      case CHANGE_ITEM_SELECTED_LOTE:
          return { ...state,
            item_selected_lote:{
            item_name: action.payload.item_name,
            item_measure_name: action.payload.item_measure_name,
            item_code: action.payload.item_code,
            }
          };

      //     case SET_ITEM_SELECTED_OUT:
      // return {
      //   ...state,
      //   item_selected_out: {
      //     ...state.item_selected_out,
      //     test_detail_id: action.payload.test_detail_id,
      //     abreviature: action.payload.abreviature,
      //     measure_id: action.payload.measure_id,
      //     quantity_consume: action.payload.quantity_consume,
      //   },
      // };
    default:
      return state;
  }
};
